export const initFontSize = function() {
  const docEl = document.documentElement,
    resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize',
    recalc = function() {
      const clientWidth = docEl.clientWidth
      if (!clientWidth) return
      docEl.style.fontSize = 16 * (clientWidth / 375) + 'px'
      window.fontSize = parseInt(docEl.style.fontSize)
    }
  recalc()
  if (!document.addEventListener) return
  window.addEventListener(resizeEvt, recalc, false)
  document.addEventListener('DOMContentLoaded', recalc, false)
  document.addEventListener('load', recalc, false)
}

export const catchHandle = ({ err, msg, cb }) => {
  let _msg = msg || '请求出错，请稍后再试'
  if (err) {
    const _err = err.toString()
    const errPrefixLen = new String('Error: ').length
    _msg = _err.slice(errPrefixLen)
  }
  cb && cb(_msg)
  return _msg
}

/**
 *
 * @param func {Function}   实际要执行的函数
 * @param wait {Number}  延迟时间，也就是阈值，单位是毫秒（ms）
 * @return {Function}     返回一个“去弹跳”了的函数
 */
export const debounce = (func, wait, immediate) => {
  let timeout, args, context, timestamp, result
  const later = function() {
    // 据上一次触发时间间隔
    const last = new Date() - timestamp
    // 上次被包装函数被调用时间间隔last小于设定时间间隔wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last)
    } else {
      timeout = null
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args)
        if (!timeout) context = args = null
      }
    }
  }

  return function() {
    context = this
    args = arguments
    timestamp = new Date()
    const callNow = immediate && !timeout
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait)
    if (callNow) {
      result = func.apply(context, args)
      context = args = null
    }

    return result
  }
}

/**
 * 让函数在规定时间内必须执行一次
 * @param {Function} func     定时执行的函数
 * @param {int}      wait  延迟多少毫秒执行
 */
export const throttle = function(func, wait, options) {
  let context, args, result
  let timeout = null
  let previous = 0
  if (!options) options = {}
  const later = function() {
    previous = options.leading === false ? 0 : Date.now()
    timeout = null
    result = func.apply(context, args)
    if (!timeout) context = args = null
  }
  return function() {
    const now = Date.now()
    if (!previous && options.leading === false) previous = now
    const remaining = wait - (now - previous)
    context = this
    args = arguments
    if (remaining <= 0 || remaining > wait) {
      if (timeout) {
        clearTimeout(timeout)
        timeout = null
      }
      previous = now
      result = func.apply(context, args)
      if (!timeout) context = args = null
    } else if (!timeout && options.trailing !== false) {
      timeout = setTimeout(later, remaining)
    }
    return result
  }
}

/**
 * window.requestAnimationFrame的兼容性写法，保证在100/6ms执行一次
 * @param  {Function} fn 100/16ms需要执行的函数
 * @return {void}
 */
export const nextFrame = (function() {
  const prefix = [ 'ms', 'moz', 'webkit', 'o' ]
  const handle = {}
  handle.requestAnimationFrame = window.requestAnimationFrame
  for (let i = 0; i < prefix.length && !handle.requestAnimationFrame; ++i) {
    handle.requestAnimationFrame = window[prefix[i] + 'RequestAnimationFrame']
  }
  if (!window.requestAnimationFrame) {
    handle.requestAnimationFrame = function(fn) {
      const raf = window.setTimeout(function() {
        fn()
      }, 16)
      return raf
    }
  }
  return function() {
    handle.requestAnimationFrame.apply(window, arguments)
  }
})()

export const playMobileSdk = num => {
  if (window.createIfm && typeof window.createIfm === 'function') {
    window.createIfm('tel', num)
  }
}

export const getQueryString = name => {
  const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
  const urlObj = window.location
  const r =
    urlObj.href.indexOf('#') > -1
      ? urlObj.hash.split('?')[1]
        ? urlObj.hash.split('?')[1].match(reg)
        : ''
      : urlObj.search.substr(1)
      ? urlObj.search.substr(1).match(reg)
      : ''
  if (r != null) return r[2] ? unescape(r[2]) : ''
  return null
}

export const bodyState = () => {
  let scrollTop = 0 // 记录滚动条位置
  return {
    setBodyNoScroll() {
      // 使body不可滚动，并记录滚动位置
      scrollTop = window.scrollY
      document.documentElement.classList.add('no-scroll')
      document.body.classList.add('no-scroll')
    },
    resetBodyState() {
      // 是页面还原滚动位置，并可滚动
      document.documentElement.classList.remove('no-scroll')
      document.body.classList.remove('no-scroll')
      scrollTop !== window.screenY && window.scrollTo(0, scrollTop)
    }
  }
}


// 时间格式化处理
export const dateFormat = (fmt, date) => {
  const o = {
    'M+': date.getMonth() + 1, //月份
    'd+': date.getDate(), //日
    'h+': date.getHours(), //小时
    'm+': date.getMinutes(), //分
    's+': date.getSeconds(), //秒
    'q+': Math.floor((date.getMonth() + 3) / 3), //季度
    S: date.getMilliseconds() //毫秒
  }
  if (/(y+)/.test(fmt)) fmt = fmt.replace(
      RegExp.$1,
      (date.getFullYear() + '').substr(4 - RegExp.$1.length)
    )
  for (const k in o) if (new RegExp('(' + k + ')').test(fmt)) fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length)
      )
  return fmt
}
